import { Link, LinkProps } from 'react-router-dom';
import cn from 'classnames';
import styles from './SidebarLink.module.css';

type Props = LinkProps & {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  active: boolean;
};

const SidebarLink = ({ icon: Icon, active, children, to }: Props): JSX.Element => (
  <Link
    className={cn(styles.sidebarLink, {
      [styles.sidebarLink_active]: active,
    })}
    to={to}
  >
    <span className={styles.sidebarLink__icon}>
      <Icon />
    </span>
    <span
      className={cn(styles.sidebarLink__title, {
        [styles.sidebarLink__title_active]: active,
      })}
    >
      {children}
    </span>
  </Link>
);

export default SidebarLink;
